import { ClientGeneral } from 'models/api/client';
import { ClientInfoTabProvider } from 'providers/ClientInfoTabProvider';
import { RefObject, useEffect, useState } from 'react';
import { Accordion, Container } from 'reactstrap';
import ClientTabPersonalInfo from '../ClientTabAccordionItems/ClientTabPersonalInfo';

export type ClientTabEditedFieldProps<T> = {
    input: T;
    reason: string;
    dsc: string;
};

const ClientTab = ({
    clientInfoQueryFn,
    isEditable,
    modalRef,
    orderId = null,
    clientId,
    isOpen,
    manualCheck = false,
}: {
    clientInfoQueryFn: () => Promise<ClientGeneral>;
    isEditable: boolean;
    modalRef?: RefObject<HTMLElement>;
    orderId?: number | null;
    clientId: number | string;
    isOpen: boolean;
    manualCheck?: boolean;
}) => {
    const [open, setOpen] = useState('personal');
    const [wasOpened, setWasOpened] = useState(false);

    useEffect(() => {
        !wasOpened && setWasOpened(isOpen);
    }, [isOpen]);

    const accordionProps = {
        open: open,
        toggle: (id: string) => setOpen((prev) => (prev === id ? '' : id)),
    };

    return (
        <ClientInfoTabProvider
            clientId={clientId}
            orderId={orderId}
            clientInfoQueryFn={clientInfoQueryFn}
            wasOpened={wasOpened}
            manualCheck={manualCheck}
        >
            <Container>
                <Accordion {...accordionProps} flush={true}>
                    <ClientTabPersonalInfo modalRef={modalRef} isEditable={isEditable} />
                </Accordion>
            </Container>
        </ClientInfoTabProvider>
    );
};

export default ClientTab;
